import { Switch, SwitchProps } from 'antd';

export type SwitchAtomProps = SwitchProps;

const SwitchAtom = Switch;

export default SwitchAtom;
